import { IconProps } from './icons-props';

function MessageIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg className={className} width={width} height={height} viewBox='0 0 24 24'>
            <path
                fill='currentColor'
                d='M22.048 6.313a6.962 6.962 0 00-4.361-4.361c-3.774-1.266-7.601-1.266-11.374 0a6.958 6.958 0 00-4.361 4.36c-1.266 3.774-1.266 7.6 0 11.374a6.96 6.96 0 004.361 4.361c1.884.632 3.797.952 5.687.952a36.18 36.18 0 009.101-1.183.998.998 0 00.716-.716A36.18 36.18 0 0023 11.999c0-1.889-.32-3.802-.952-5.687zm-14.112.665h2.904a1 1 0 010 2H7.936a1 1 0 010-2zm8.128 10.043H7.936a1 1 0 010-2h8.128a1 1 0 010 2zm1-4.021H6.936a1 1 0 010-2h10.128a1 1 0 010 2z'
            />
        </svg>
    );
}

export default MessageIcon;

